export var oteljsVersion = '4.23.36';
//# sourceMappingURL=Version.js.map